<template>
  <!--
    Tailwind UI components require Tailwind CSS v1.8 and the @tailwindcss/ui plugin.
    Read the documentation to get started: https://tailwindui.com/documentation
  -->
  <div class="md:ml-4">
    <sonicu-header>
        Shortcuts
    </sonicu-header>
<!--    <h2 class="text-gray-500 text-xs font-medium uppercase tracking-wide">Pinned Projects</h2>-->
    <ul class="mt-3 grid grid-cols-2 gap-5 sm:gap-5 md:grid-cols-1">
      <li v-for="link in links"
          class="col-span-1">
        <a :href="link.link" class="plain-link col-span-1 flex shadow-sm rounded-md">
          <div class="shrink-0 flex items-center justify-center w-10 md:w-16 text-white text-sm bg-blue-500 leading-5 font-medium rounded-l-md">
            <span :class="link.icon" class="lnr text-white"></span>
          </div>
          <div
              class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
            <div class="flex-1 px-4 py-4 text-sm leading-5 truncate">
              <span class="text-gray-900 font-medium hover:text-gray-600">
                {{link.text}}
              </span>
            </div>
            <div class="hidden sm:block shrink-0 pr-2">
              <button
                  class="w-8 h-8 inline-flex items-center justify-center text-gray-400 rounded-full bg-transparent hover:text-gray-500 focus:outline-none focus:text-gray-500 focus:bg-gray-100">
                <span class="lnr icon-arrow-right"></span>
              </button>
            </div>
          </div>
        </a>
      </li>
    </ul>
  </div>

</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";

export default {
  name: "dashboardShortcuts",
  mixins: [SonicuCoreMixin],
  props: {
    hasCalibration: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
    }
  },
  computed:{
    links() {
        let optionalLink = {'text': 'Academy', 'icon': 'icon-graduation-hat', 'link': 'https://www.sonicu.com/academy'};
        if(this.hasCalibration){
          optionalLink = {'text': 'Calibrations', 'icon': 'icon-calendar-check', 'link': this.company.buildCompanyRoute('site-admin/calibration-info')};
        }
      return [
        {'text': 'Alarms', 'icon': 'icon-alarm2', 'link': this.company.buildCompanyRoute('alarms')},
        {'text': 'Reports', 'icon': 'icon-clipboard-empty', 'link': this.company.buildCompanyRoute('reports')},
        optionalLink,
        {'text': 'Support', 'icon': 'icon-telephone', 'link': this.company.buildCompanyRoute('support')},
      ]
    }
  }
}
</script>

<style scoped>

</style>